import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "formIsOpen", false);
        Vue.set(state, "gridIsOpen", true);
    },
    setFormOpenEprofileAutonomia(state) {
        state.formIsOpen = true;
        state.gridIsOpen = false;
    },
    setFormCloseEprofileAutonomia(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
    }
}
